export const rNames = {

    // news
    blogs: 'news',

    // base
    id: 'id',
    slug: 'slug',
    add: 'add',
    edit: 'edit',
    detail: 'detail',
    remove: 'remove',
    report: 'report',

    // тарифы и оплата подписки
    pricing: 'pricing',

    // auth
    login: 'login',
    register: 'register',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    confirmEmail: 'confirm-email',
    // #784: приёмник JWT после OAuth-колбэка бэкенда
    authExternal: 'auth/external',

    // admin, account
    admin: 'admin',
    account: 'account',
    accountCheckPayment: 'check-payment',
    accountPremium: 'premium',
    accountPassword: 'password',
    accountEmail: 'email',

    // users
    users: 'users',

    // categories
    catNested: 'categories',
    catParent: 'parent-categories',

    // errors
    error404: '404',

    // tags
    tags: 'tags',

    // favorites
    favorites: 'favorites',
    coursesFavorites: 'courses-favorites',

    // кабинет: прогресс по курсам — «где я остановился»
    accountCoursesProgress: 'courses-progress',

    // comments
    comments: 'comments',
    commentWaitModer: 'wait-moderation',

    // admin url copier (Яндекс.Вебмастер)
    urls: 'urls',

    // admin: настройки оплаты и заявки
    adminPayments: 'payments',

    // admin: оформление — палитры темы
    adminAppearance: 'appearance',

    // admin: базовые параметры калькуляторов (ставки, утильсбор, пошлины — S-0214)
    adminCalcParams: 'calculators',

    // admin: письма сайта — тексты шаблонов и адрес уведомлений (#488)
    adminMail: 'mail',

    // курсы валют
    currencies: 'currencies',

    // курсы (раздел перенесён из courses-2023/pselector)
    courses: 'courses',

    // временная привязка игры ItFarm
    gameIt: 'game-it',

    // юзерскрипты
    userscripts: 'userscripts',
    donate: 'donate',

    // calcs
    calcs: 'calculators',
    calcPercents: 'percents',
    nds: 'nds',
    calcOhm: 'ohm',
    calcCable: 'cable-section',
    calcLed: 'led-resistor',
    calcDivider: 'voltage-divider',
    calcResistorColor: 'resistor-colors',
    calcSeries: 'series-parallel',
    calcNe555: 'ne555',
    calcLm317: 'lm317',
    calcBattery: 'battery-life',
    calcElectricity: 'electricity-cost',
    calcPowerCurrent: 'power-current',
    calcCompound: 'compound-interest',
    calcCredit: 'credit',
    calcDiscount: 'discount',
    calcRc: 'rc-filter',
    calcLc: 'lc-resonance',
    calcDbm: 'dbm-watt',
    calcWavelength: 'wavelength',
    calcOpamp: 'opamp-gain',
    calcZener: 'zener-resistor',
    calcWireResistance: 'wire-resistance',
    calcPwm: 'pwm',
    calcBase: 'number-base',
    calcDataUnits: 'data-units',
    calcInflation: 'inflation',
    calcVoltageDrop: 'voltage-drop',
    calcLedChain: 'led-chain',
    calcTransistorBase: 'transistor-base',
    calcBmi: 'bmi',
    calcDateDiff: 'date-diff',
    calcUnits: 'units-converter',
    calcAdc: 'adc',
    calcRcTiming: 'rc-timing',
    calcE24: 'e24-resistor',
    calcLedStrip: 'led-strip-power',

    // авто
    calcFuel: 'fuel-consumption',
    calcEnginePower: 'engine-power',
    calcCarImport: 'car-import',
    calcTransportTax: 'transport-tax',
    calcRecyclingFee: 'recycling-fee',

    // финансы, налоги и зарплата (S-0187…S-0194)
    calcMortgage: 'mortgage',
    calcDeposit: 'deposit',
    calcNdfl: 'ndfl',
    calcPenalty: 'penalty',
    calcVacation: 'vacation-pay',

    // электроника (S-0191, S-0193)
    calcDecibel: 'decibel',
    calcSmd: 'smd-marking',


}
